<template>
    <div class="well-summary-mobile">
        <i class="fa fa-chevron-left back-arrow" @click="backToTreatment" />

        <div class="moving">
            <div class="credentials">
                <i class="fa fa-circle" :style="`color: ${selectedPatient.color}`" />
                <div class="well-data">
                    <template v-if="isGeriOrMiri"> <well-chamber-number />&nbsp;|&nbsp; </template>
                    <well-id :well="focusedWell" />
                    <well-embryo-id-view :well="focusedWell" />
                </div>
            </div>

            <div class="key-score-metrics">
                <template v-if="!isFdaFriendly">
                    <well-rank :well="focusedWell" />

                    <kid-score
                        option="well-card-option"
                        :well="focusedWell"
                        :only-background-high-score="true"
                    />

                    <blast-score
                        option="well-card-option"
                        :well="focusedWell"
                        :only-background-high-score="false"
                    />
                </template>

                <div class="well-card-option">
                    <well-status-dropdown :well="focusedWell">
                        <div class="latest-pic">
                            <img :src="focusedWell.lastImageUrl" :draggable="false" alt="" />
                            <well-status-overlay :well="focusedWell" />
                        </div>
                    </well-status-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import WellId from '../WellId'
import WellRank from '../common/WellRank'
import KidScore from '../score-metrics/KidScore'
import BlastScore from '../score-metrics/BlastScore'
import WellEmbryoIdView from '../common/WellEmbryoIdView'
import WellStatusDropdown from './WellStatusDropdown'
import WellStatusOverlay from '../common/WellStatusOverlay'
import WellChamberNumber from '../WellChamberNumber'
import { INSTRUMENT_TYPE } from '../../../business/const'

export default {
    name: 'WellSummaryMobile',
    components: {
        WellId,
        WellEmbryoIdView,
        WellRank,
        KidScore,
        BlastScore,
        WellStatusDropdown,
        WellStatusOverlay,
        WellChamberNumber
    },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            selectedSlide: state => state.timelapse.selectedSlide,
            selectedPatient: state => state.timelapse.selectedPatient,
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        isGeriOrMiri() {
            return (
                this.getSelectedInstrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(
                    this.getSelectedInstrument.type
                )
            )
        }
    },
    methods: {
        backToTreatment() {
            this.$store.dispatch('navigation/navigateBack', {
                treatment: this.selectedTreatment,
                slide: this.selectedSlide
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.well-summary-mobile {
    display: flex;
    background-color: $dark;
    align-items: center;

    .fa-chevron-left {
        font-size: 18px;
    }
    .back-arrow {
        color: $blue;

        @media screen and #{$new-break1} {
            width: 20px;
            margin-left: 0.75rem;
        }

        @media screen and #{$new-break2open} {
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }
    .credentials {
        display: flex;
        align-items: center;

        .fa-circle {
            font-size: 10px;
            margin-right: 10px;
        }

        .well-embryo-id-view {
            margin: 0 0.5rem;
        }
        .well-data {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .key-score-metrics {
        min-width: 18rem;
        margin-left: 1rem;
        display: grid;
        column-gap: 0.5rem;
        grid-template-columns: repeat(4, 1fr);
    }
    .moving {
        display: flex;
        align-items: center;
        padding: 5px;
        overflow-x: auto;
        overflow-y: hidden;

        &:has(.well-status-dropdown) {
            overflow: visible;
        }
        @media screen and #{$new-break1} {
            flex-flow: row nowrap;
            align-items: center;
        }
    }
}
</style>

<style lang="scss">
.well-summary-mobile {
    .well-rank {
        .title {
            font-size: 8pt;
        }

        .value {
            font-size: 11pt;

            .ai-icon {
                height: 14px;
                margin-right: 0.25rem;
            }
        }

        &.top-rank .crown {
            width: 1rem;
        }
    }
    .latest-pic {
        position: relative;
        cursor: pointer;

        img {
            height: 3.5rem;
            width: 3.5rem;
            border-radius: $border-radius;
        }
    }
}
</style>
